import { useDomainControlStore } from "@/stores/domainControl";
import { watch } from "vue";
import { ref } from "vue";

export function setupTimeInterval() {
  const time = ref(Date.now());
  const index = ref(-1);
  const timexList = ref([] as number[]);
  const domainControlStore = useDomainControlStore();
  watch(
    () => domainControlStore.printInterval,
    (value) => {
      if (value) {
        time.value = Date.now();
        index.value = -1;
        timexList.value = [];
      }
    }
  );

  function updateTimeInterval() {
    const now = Date.now();
    const timex = now - time.value;
    time.value = now;
    index.value++;
    if (index.value !== 0) {
      timexList.value.push(timex);
      const average =
        timexList.value.reduce((pre, cur) => pre + cur, 0) / index.value;

      domainControlStore.changeNotifyInterval(average);
      console.log(
        "[BOWEN_LOG] 🚀 ~~~ updateTimeInterval ~~~ timexList.value.reduce((pre, cur) => pre + cur):",
        timexList.value.reduce((pre, cur) => pre + cur)
      );
      console.log(
        "[BOWEN_LOG] 🚀 ~~~ updateTimeInterval ~~~ 时间间隔 average:",
        average
      );
      console.log("[BOWEN_LOG] 🚀 ~~~ updateTimeInterval ~~~ 时间间隔:", timex);
    }
  }

  return {
    updateTimeInterval,
  };
}
